export function bytesToMB(sizeInBytes: number): number {
  return Number((sizeInBytes / (1024 * 1024)).toFixed(2));
}
